import React, { useMemo } from 'react';
import { uniqueId } from 'lodash';
import { map } from 'lodash';
import { LinePath } from '@visx/shape';
import { curveMonotoneX } from '@visx/curve';
import { useGlobalSvgMask } from '../GlobalSvgMasks';

import { Ring } from './Ring';

const LineWithRings = ({ x, y, data, curve = curveMonotoneX, ...props }) => {
  const strippedData = useMemo(
    () => data.filter((d) => typeof d === 'object'),
    [data]
  );

  const maskId = useMemo(() => uniqueId('line-with-rings-mask-'), []);

  useGlobalSvgMask(
    maskId,
    <g>
      <LinePath className="line-mask" data={data} x={x} y={y} curve={curve} />
      <g>
        {map(strippedData, (d, i) => (
          <circle key={i} cx={x(d)} cy={y(d)} r={7} fill="black" />
        ))}
      </g>
    </g>
  );

  return (
    <g {...props}>
      <g>
        <LinePath
          mask={`url(#${maskId})`}
          className="connector-line palette-stroke"
          data={data}
          x={x}
          y={y}
          curve={curve}
        />
        <g>
          {map(strippedData, (d, i) => (
            <Ring key={i} cx={x(d)} cy={y(d)} />
          ))}
        </g>
      </g>
    </g>
  );
};

export default LineWithRings;
